import { useState } from "react";

import { Clear } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import { useDebounce } from "hooks/useDebounce";

export const SearchSettingsTextField = ({ value, setValue, onKeyDownCallback, fullWidth = true, sx = [], ...props }) => {
	const debouncedSetValue = useDebounce(setValue);

	const [searchText, setSearchText] = useState(value);

	return (
		<TextField
			size="small"
			fullWidth={fullWidth}
			value={searchText}
			onChange={(e) => {
				const newValue = e.target.value;
				setSearchText(newValue);
				debouncedSetValue(newValue);
			}}
			InputLabelProps={{
				shrink: true,
			}}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end" sx={{ opacity: searchText ? 1 : 0 }}>
						<IconButton
							size="small"
							sx={{ padding: "2px" }}
							onClick={() => {
								setSearchText("");
								debouncedSetValue("");
							}}
						>
							<Clear sx={{ fontSize: "16px" }} />
						</IconButton>
					</InputAdornment>
				),
			}}
			sx={[
				{
					"& .MuiOutlinedInput-input": {
						padding: "2px 6px",
						fontSize: "12px",
					},
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
			onKeyDown={(e) => {
				if (["Enter", "NumpadEnter"].includes(e.code)) {
					onKeyDownCallback?.();
				}
			}}
			{...props}
		/>
	);
};
